import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "./PreviewStep.css";

const PreviewStep = ({ step, next, slug, isd, mobile, urlQuery }) => {
  const { t} = useTranslation();
  const [progress, setProgress] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const navigate = useNavigate();

  const [accuracy, setAccuracy] = useState(92);

  // 🎯 Random accuracy
  useEffect(() => {
    const random = Math.floor(Math.random() * 4) + 92;
    setAccuracy(random);
  }, [step]);

  // 🎯 Show result after 5 sec
  useEffect(() => {
    setShowResult(false);

    const timer = setTimeout(() => {
      setShowResult(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, [step]);

  // 🎯 Auto next after result
  useEffect(() => {
    if (showResult && step >= 3 && step <= 6) {
      const timer = setTimeout(() => {
        next();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showResult, step]);

  // 🎯 Progress logic (main part 🔥)
  useEffect(() => {
    if (step >= 3 && step <= 6) {
      const stepIndex = step - 3; // 0,1,2,3
      const start = stepIndex * 25;
      const end = start + 25;

      setProgress(start);

      let current = start;

      const interval = setInterval(() => {
        current += 1;
        setProgress(current);

        if (current >= end) {
          clearInterval(interval);
        }
      }, 50); // smooth animation

      return () => clearInterval(interval);
    }
  }, [step]);

  const getContent = () => {
    switch (step) {
      case 3:
        return { type: "File Type: PDF", title: "Floor Plan", option: "Option 1", desc: "Rendering.. Floor Plan Option1", img: "floor-plan.jpg" };
      case 4:
        return { type: "File Type: PDF", title: "Floor Plan", option: "Option 2", desc: "Rendering.. Floor Plan Option2", img: "floor-plan.jpg" };
      case 5:
        return { type: "File Type: JPG", title: "Elevation Plan", option: "Option 1", desc: "Rendering.. 3D Elevation Option1", img: "elevation.jpg" };
      case 6:
        return { type: "File Type: JPG", title: "Elevation Plan", option: "Option 2", desc: "Rendering.. 3D Elevation Option2", img: "elevation.jpg" };
      default:
        return {};
    }
  };

  const data = getContent();

  return (
    <div className="preview-wrapper">

      {/* 🔥 Progress Bar */}
      {step >= 3 && step <= 6 && (
        <div className="progress-bar-container">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}

      {/* Top Section */}
      <div className="top-section">
        {!showResult ? (
          <>
            <h2>{t(data.desc)}</h2>
            <p>{progress}%  {t("completed")}</p>
          </>
        ) : (
          <div className="status">✅ {t("Rendered Successfully")}</div>
        )}
      </div>

      {/* Loading */}
      {!showResult && (
        <>
          <div className="progress-circle">
            <div className="circle">
              <span>🏠</span>
            </div>
          </div>
          <div className="wave" />
        </>
      )}

      {/* Result */}
      {showResult && (
        <>
          <div className="preview-image-wrapper">
            <img
              src={`https://mailer-assets.makemyhouse.com/hpn-video/${data.img}`}
              className="preview-image"
              alt="preview"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>

          <div className="result-card">
            <div className="ready-badge">
              <span className="ready-dot" />
              <span>{t("READY")}</span>
            </div>

            <div className="info">
              <div className="info-row">
                <span>📄 <strong>{t(data.type)}</strong></span>
                <span className="accuracy-badge">✅ {accuracy}% {t("Accurate")}</span>
              </div>
              <p>{t(data.title)} · {t(data.option)}</p>
            </div>

            {/* ❌ Button removed for step 3–6 */}
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewStep;